export default __webpack_public_path__ + "static/media/mosaic.da9f571a.svg";